import { createSlice } from '@reduxjs/toolkit';
import type { RirekishoBasicInfo } from '@src/api/core/api-types';
import { createSimpleSliceReducers } from '../helpers/slice_helpers';

const initialState: RirekishoBasicInfo = {
  lastName: '',
  firstName: '',
  lastNameReading: '',
  firstNameReading: '',
  gender: 'male',
  birthDate: '',
  currentDate: '',
  age: 0,
};

const rirekishoBasicInfoSlice = createSlice({
  name: 'rirekishoBasicInfo',
  initialState,
  reducers: createSimpleSliceReducers<RirekishoBasicInfo>(),
});

export const { update: updateRirekishoBasicInfo } = rirekishoBasicInfoSlice.actions;

export default rirekishoBasicInfoSlice.reducer;
